module.exports = __webpack_public_path__ + "static/media/accreditation_settings.e38407f6.svg";